export default __webpack_public_path__ + "static/pettingSeated-dab12d368537e9fef39690889f3fa477.svg";